import React from 'react';
import { Modal } from 'elements';
import { WrappedMessage } from 'utils';
import { Career } from 'labxchange-client';
import messages from './displayMessages';

interface RemoveCareerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRemove: () => void;
  career?: Career | null;
}

const RemoveCareerModal: React.FC<RemoveCareerModalProps> = ({
  isOpen,
  onClose,
  onRemove,
  career,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      size='normal'
      className='remove-modal-content'
      contentPadding={0}
      content={
        <>
          <p className='modal-text'>
            <WrappedMessage
              message={messages.removeCareerConfirmationText}
              values={{ careerName: <strong>{career?.title}</strong> }}
            />
          </p>
          <div className='action-buttons'>
            <button className='btn cancel' onClick={onClose}>
              <WrappedMessage message={messages.cancelButtonText} />
            </button>
            <button className='btn remove' onClick={onRemove}>
              <WrappedMessage message={messages.removeButtonText} />
            </button>
          </div>
        </>
      }
    />
  );
};

export default RemoveCareerModal;
